/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface Ups
 */
export interface Ups {
    /**
     * 
     * @type {string}
     * @memberof Ups
     */
    deviceId: string;
    /**
     * 
     * @type {number}
     * @memberof Ups
     */
    manageSerial: number;
}

export function UpsFromJSON(json: any): Ups {
    return UpsFromJSONTyped(json, false);
}

export function UpsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceId': json['deviceId'],
        'manageSerial': json['manageSerial'],
    };
}

export function UpsToJSON(value?: Ups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceId': value.deviceId,
        'manageSerial': value.manageSerial,
    };
}


